import {Component, Input, NgZone, OnInit} from '@angular/core';
import {Events} from "../../../../../framework/providers/events";
import {AdminService} from "../../../services/AdminService";
import {NavController, Platform} from "@ionic/angular";

@Component({
    selector: 'app-onechat-option',
    templateUrl: './onechat-option.component.html',
    styleUrls: ['./onechat-option.component.scss'],
})
export class OnechatOptionComponent implements OnInit {
    @Input()
    res = {};
    @Input()
    option = {};

    @Input()
    displayType = 'menu';
    @Input()
    ticket_results = {}
    @Input()
    checked_list_key = {}
    @Input()
    checked_list_topkey = {}
    @Input()
    color = ''

    isOpened = false;

    hide_image_banner = false;
    tableData = [];

    constructor(public events: Events, public adminService: AdminService, private platform: Platform,
                public navCtrl: NavController) {
    }

    ngOnInit() {
        // if (this.option['display'] == 'banner') {
        //     let me = this;
        //     setTimeout(function () {
        //         me.hide_image_banner = true;
        //     }, 3000);
        // }
    }

    chooseOption(event, option) {
        if (option['waze']) {
            this.events.publish('open_map', option['waze'])
            return
        }

        if (option['sub_model_table_option']) {
            this.adminService.goto(this.navCtrl, 'chat/' + Math.floor(Math.random() * Math.floor(1000000)),
                {'option': option['sub_model_table_option']});
            return;
        }

        if (option['model_page']) {
            this.adminService.openCustomModel(this.navCtrl, '77gggg', null, option['model_name'],
                null, null, option['model_id'], null, null, false, {}, true)
            return
        }
        if (option['type'] && option['type'] == 'model_page') {
            this.adminService.openCustomTable(this.navCtrl, 'asdasdqw', this.adminService.manageModels, option['sectionName'],
                null, null, null, true, true);
            return
        } else if (option['server_call']) {
            this.adminService.goto(this.navCtrl, 'chat/' + Math.floor(Math.random() * Math.floor(1000000)), {'option': option});
        } else {
            option['open_box'] = !!!option['open_box'];
        }
        // option.checked = !!!option.checked;
        // if (option['subs'] && option['subs'].length > 0 || true) {
        // this.ask(option);
        // this.events.publish('chooseOption', option);
        // } else {
        //     this.isOpened = !this.isOpened;
        //     event.stopPropagation();
        // }

    }

    ask(option) {
        this.events.publish('chooseOption', option);
    }


    removeOption(option, mfilters = {}) {

        this.events.publish('removeOption', {'option': option, 'filters': mfilters});
    }


}
